<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Configuração de Eventos | Criar" />
    <v-row justify="center" align="center">
      <v-col>
        <form-event-configuration v-model="model" @submit="submit" />
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import TPageTitle from '@/components/TPageTitle.vue'
import FormEventConfiguration from './form/form-event-configuration.vue'
import EventConfigurationService from '@/services/EventConfigurationService'
import EventConfiguration from '@/types/EventConfiguration'
import { useSnackBar } from '@/stores/snackbar'
import { useLoader } from '@/stores/loader'
import { useRouter } from 'vue-router'
import { PrintingTemplate } from '@/constants/PrintingTemplates'
import { VoucherTemplate } from '@/constants/VoucherTemplates'

const loader = useLoader()

const router = useRouter()

const snackbar = useSnackBar()

const service = new EventConfigurationService()

const model = ref<EventConfiguration>({
  type: 1,
  template: PrintingTemplate.QRCODE,
  template_type: VoucherTemplate.ACCESS,
  active: true,
} as EventConfiguration)

async function submit(model: EventConfiguration) {
  try {
    loader.increment()

    const { data } = await service.store(model)

    snackbar.show('Configuração salva com sucesso', 'success')

    router.push({ name: 'edit-event-configuration', params: { id: data.id } })
  } finally {
    loader.decrement()
  }
}

</script>
